import React, { useEffect, useState, useContext } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import { MasterContext, OrderContext } from '../../ContextApi/context';
import OrderFunctions from '../../OrderSettings/OrderFunctions';
import PopUpMsg from '../PopUpMsg';

const Delivery_Confirmd = (props) => {
    const [master] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);

    // שומר עותק בטוח של ההזמנה (גם אם היא בקונטרולר או ב-context)
    const [CorntOrdr] = useState(() =>
        JSON.parse(JSON.stringify(props.order?.ordr || props.order))
    );

    // מנקה את ההזמנה הגלובלית רק אחרי שהקומפוננט נטען
    useEffect(() => {
        // setTimeout(() => {
        //     setOrder(OrderFunctions.clearOrd());

        // }, 100);
    }, []);

    return (
        <PopUpMsg
            Title={["ההזמנה בוצעה"]}
            nosnippet={true}
            ContentText={[
                { txt: "המסעדה מתחילה להכין את ההזמנה.", css: "" },
                { txt: "שליח ידפוק אצלך בדלת", css: "" },
                { txt: `בערך בעוד ${CorntOrdr.OrderTimes} דקות`, css: "" },
                { txt: `מספר הזמנה: ${CorntOrdr.orderNUM}`, css: "" },
                {
                    txt: CorntOrdr.transactionId
                        ? `מספר אישור עסקה: ${CorntOrdr.transactionId}`
                        : "חיוב לא בוצע",
                    css: ""
                }
            ]}
            inLabel={""}
            BottomTitle={["בתאבון!"]}
            topImg={`${ConnUrls.servMediasUrl}${master.orderApprovImg}`}
            cssStyl={"approveMsgPopup"}
            okClick={() => { props.okClick(); setOrder(OrderFunctions.clearOrd()) }}
            errorMsg={""}
        />
    );
};

export default Delivery_Confirmd;
